// NPM Requirements
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';

// Actions
import userActions from '../../actions/userActions';

class UnsubscribeShiftAvailable extends Component {
  constructor(props) {
    super(props);
    this.unsubscribeUser = this.unsubscribeUser.bind(this);

    this.state = {
      loading: true
    };
  }

  componentDidMount() {
    if (this.props.auth.userData) {
      this.unsubscribeUser(this.props.auth.userData.id);
    }
  }

  unsubscribeUser(userId) {
    const data = {
      id: userId,
      get_shift_available_notifications: false
    }

    this.props.updateUser(data).then((response) => {
      this.setState({ loading: false });
    });
  }

  render() {
    const { loading } = this.state;

    if (loading) {
      return (
        <section className="CenteredSection PaddedSection">
          <div className="CenteredSection-inner">
            <div className="Loader Loader--center">
              Loading
            </div>
          </div>
        </section>
      );
    }

    return (
      <section className="CenteredSection PaddedSection">
        <div className="CenteredSection-inner">
          <h3>Unsubscribe Successful</h3>
          <p>You will no longer recieve email notifications of newly available shifts.</p>
          <div className="u-flex">
            <Link
              to="/vendor"
              className="Button u-mb1 u-mr05"
            >
              Home
            </Link>
            <Link
              to="/account"
              className="Button u-mb1"
            >
              View Account Settings
            </Link>
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    auth: state.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateUser(record) {
      return dispatch(userActions.update(record));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UnsubscribeShiftAvailable));
